/**
 * Money — read-only amount display. Mono + LTR island so centimes render identically under RTL.
 * Negative amounts are tinted danger (with a sign, never color-only).
 */
import { formatCentimes } from "../money";

export interface MoneyProps {
  centimes: number | null | undefined;
  withCurrency?: boolean | undefined;
  /** Emphasize as a primary figure (larger, ink). */
  strong?: boolean | undefined;
  /** Tint negative values danger (still carries the minus sign). */
  signed?: boolean | undefined;
}

export function Money({ centimes, withCurrency = true, strong, signed }: MoneyProps) {
  const isNeg = signed && typeof centimes === "number" && centimes < 0;
  return (
    <span
      className="nv-mono nv-ltr-island"
      style={{
        fontVariantNumeric: "tabular-nums",
        fontWeight: strong ? 600 : 400,
        color: isNeg ? "var(--nv-danger)" : strong ? "var(--nv-ink)" : "inherit",
        whiteSpace: "nowrap",
      }}
    >
      {formatCentimes(centimes, withCurrency)}
    </span>
  );
}
